import { render, staticRenderFns } from "./BusinessEntitiesRegister.vue?vue&type=template&id=995b539a&scoped=true&"
import script from "./BusinessEntitiesRegister.vue?vue&type=script&lang=js&"
export * from "./BusinessEntitiesRegister.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEntitiesRegister.vue?vue&type=style&index=0&id=995b539a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995b539a",
  null
  
)

export default component.exports